if (typeof NodeList !== "undefined" &&
    NodeList.prototype &&
    !NodeList.prototype.forEach) {
    Object.defineProperty(NodeList.prototype, "forEach", {
      value: Array.prototype.forEach
    });
}



// WEBPACK FOOTER //
// ./src/utils/polyfill.js